/**
 * @generated SignedSource<<238e0c53276fd9a9efc5d0ca04e91bc7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type articleListArticle$data = {
  readonly " $fragmentSpreads": FragmentRefs<"articleFooterArticle" | "articlePaginationCheckerArticle" | "articlePaginationNavigationHistoryArticle" | "articlePaywallCheckerContent" | "articleRecommendationArticle" | "articleRenderArticle" | "contextsContentReadMoreContextProviderContent" | "helpersArticleSections" | "topBannerContent">;
  readonly " $fragmentType": "articleListArticle";
};
export type articleListArticle$key = {
  readonly " $data"?: articleListArticle$data;
  readonly " $fragmentSpreads": FragmentRefs<"articleListArticle">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "kind": "Variable",
    "name": "customContents",
    "variableName": "customContents"
  }
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": [],
      "kind": "LocalArgument",
      "name": "customContents"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "articleListArticle",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "topBannerContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "articleFooterArticle"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "articlePaginationCheckerArticle"
    },
    {
      "args": (v0/*: any*/),
      "kind": "FragmentSpread",
      "name": "articlePaginationNavigationHistoryArticle"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "articleRecommendationArticle"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "articlePaywallCheckerContent"
    },
    {
      "args": (v0/*: any*/),
      "kind": "FragmentSpread",
      "name": "articleRenderArticle"
    },
    {
      "kind": "InlineDataFragmentSpread",
      "name": "helpersArticleSections",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "SectionSegment",
          "kind": "LinkedField",
          "name": "sections",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Section",
              "kind": "LinkedField",
              "name": "value",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "entityId",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "args": null,
      "argumentDefinitions": []
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "contextsContentReadMoreContextProviderContent"
    }
  ],
  "type": "Article",
  "abstractKey": null
};
})();

(node as any).hash = "838ee33f1737df887bd789ef105ca4a1";

export default node;
